// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWrapperStyle-module--wrapper--2itil","title_holder":"LayoutWrapperStyle-module--title_holder--2g9Ph"};